export default class Config {
  public static readonly ENV: any = { ...process.env };
  public static readonly IS_PROD: boolean =
    Config.ENV.NODE_ENV === 'production';
  public static readonly LOCAL_STORAGE_PREFIX: string = 'UPSERVICE_ADMIN_';
  public static readonly API_ROOT: string = '/api/';
  public static readonly GRAPHQL_ROOT: string =
    process.env.NODE_ENV === 'production'
      ? 'https://upservice.upfeat.com/graphql'
      : '/graphql';
  public static readonly JWT_TOKEN_REFRESH_TIME: number = 60;
  public static TRANSLATION_CACHE_MINUTES: number = 10;
  public static readonly ROOT_URL: string = Config.IS_PROD
    ? 'https://upservice.upfeat.com/'
    : 'http://127.0.0.1:81/';
  public static INTERCOM_APP_ID: string = 'g2du01mc';
}
